export enum Step0FormNames {
    ALLIANZ_PAY_DESCRIPTION = 'allianzPayDescription',
    ALLIANZ_PAY_CODE = 'allianzPayCode'
}
export enum Step1FormNames {}
export enum Step3FormNames {}

export enum Step2FormNames {
  TELEPHONE = 'stepTwoTelephone',
  EMAIL = 'email',
  CONFIRM_EMAIL = 'emailConfirm',
  FISCAL_CODE = 'fiscalCode',
  ADDRESS = 'stepTwoAddress',
  SHIPPING_ADDRESS = 'shippingAddress',
}
export enum AddressFormNames {
  ADDRESS = 'address',
  HOUSE_NUMBER = 'houseNumber',
  ZIP_CODE = 'zipCode',
  CITY = 'city',
  PROVINCE = 'province',
}

export enum AddressFormUuids {
  ADDRESS = 'c005',
  HOUSE_NUMBER = 'c006',
  ZIP_CODE = 'c007',
  CITY = 'c008',
  PROVINCE = 'c009',
}
export enum ShippingAddressFormUuids {
  ADDRESS = 'e004',
  HOUSE_NUMBER = 'e005',
  ZIP_CODE = 'e006',
  CITY = 'e007',
  PROVINCE = 'e008',
}

export enum Step4FormNames {
  TELEPHONE = 'contactsTelephone',
  EMAIL = 'contactsEmail',
  PRIVACY = 'contactsPrivacy',
  GEOLOCATOR = 'contactsAgency',
  GENERAL_AGREEMENT = 'generalAgreement',
  OTHER_AGREEMENT = 'otherAgreement',
}
export enum PrivacyFormNames {
  PROMOTIONAL_ACTIVITIES = 'specialOffer',
  PROFILATION = 'profile',
  MARKET_INVESTIGATION = 'survey',
  PROMOTIONAL_ACTIVITIES_THIRD_PARTIES = 'partnerPromo',
}
